var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import { Box, Button, Stack, SwipeableDrawer, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import IosShareOutlinedIcon from '@mui/icons-material/IosShareOutlined';
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import SearchField from "../../components/FormComponents/SearchField";
import AutoCompleteDD from "../../components/FormComponents/AutoCompleteDD";
import { api_service } from "../../api/api_service";
import { api_urls } from "../../api/api_urls";
import moment from "moment";
import EditApplicationDrawer from "./EditApplicationDrawer";
import ViewApplicationDetailsDialog from "./ViewApplicationDetailsDialog";
import ConfirmationAndInformationPoup, { POPUP_TYPE } from "../../components/UtilityComponents/ConfirmationAndInformationPoup";
import { utility } from "../../utils";
import SvelteJSONEditor from "../dealerManagement/JsonEditor";
import { deepEqual } from "../../utils/commonUtilities";
import { useSelector } from 'react-redux';
import CommonTab from "../../components/tabComponent/CommonTab";
import ResubmitStatusPills from "./components/ResubmitStatusPills";
import ResubmitTableSection from "./ResubmitTableSection";
import { baseColors, colors } from "../../Themes/colors";
import { applicationResubmitStatus } from "../../config/constants";
import { exportApplications } from "./components/exportUtils";
var EXPORT_COLOR = colors.blueShades[9];
var TOOLBAR_CONTROL_HEIGHT = 40;
var TabLabelWithCount = function (_a) {
    var label = _a.label, count = _a.count;
    return (React.createElement("span", null, count !== undefined ? "".concat(label, " (").concat(count, ")") : label));
};
var safeJsonParse = function (value) {
    if (value === null || value === undefined || value === '')
        return null;
    if (typeof value !== 'string')
        return value;
    try {
        return JSON.parse(value);
    }
    catch (_a) {
        return null;
    }
};
var REQ_DOCS_STATUS_MAP = {
    Failed: applicationResubmitStatus.FAILED,
    Processing: applicationResubmitStatus.PROCESSING,
    Completed: applicationResubmitStatus.COMPLETED,
    Deleted: applicationResubmitStatus.DELETED,
};
var STATUS_VALUE_TO_KEY = (_a = {},
    _a[applicationResubmitStatus.FAILED] = 'Failed',
    _a[applicationResubmitStatus.PROCESSING] = 'Processing',
    _a[applicationResubmitStatus.COMPLETED] = 'Completed',
    _a[applicationResubmitStatus.DELETED] = 'Deleted',
    _a);
var ResubmitApplication = function () {
    var userBasicInfo = useSelector(function (store) { return store.User.userData; });
    var rolePermissions = (userBasicInfo === null || userBasicInfo === void 0 ? void 0 : userBasicInfo.RolePermissions) || [];
    var resubmitPermission = rolePermissions.find(function (perm) { return perm.PermissionKey === 'ADMINISTRATOR:RESUBMIT_APPLICATION'; });
    var canView = (resubmitPermission === null || resubmitPermission === void 0 ? void 0 : resubmitPermission.View) === 1;
    var canAdd = (resubmitPermission === null || resubmitPermission === void 0 ? void 0 : resubmitPermission.Add) === 1;
    var canUpdate = (resubmitPermission === null || resubmitPermission === void 0 ? void 0 : resubmitPermission.Update) === 1;
    var canDelete = (resubmitPermission === null || resubmitPermission === void 0 ? void 0 : resubmitPermission.Delete) === 1;
    var _a = useState('all'), selectedPortal = _a[0], setSelectedPortal = _a[1];
    var _b = useState(), searchText = _b[0], setSearchText = _b[1];
    var _c = useState(false), open = _c[0], setOpen = _c[1];
    var _d = useState(''), userAction = _d[0], setUserAction = _d[1];
    var _e = useState(undefined), vendorList = _e[0], setVendorList = _e[1];
    var _f = useState({ Id: 'all', Name: 'All' }), selectedVendor = _f[0], setSelectedVendor = _f[1];
    var _g = useState([]), adminList = _g[0], setAdminList = _g[1];
    var _h = useState(false), isFetching = _h[0], setIsFetching = _h[1];
    var _j = useState([]), freezedList = _j[0], setFreezedList = _j[1];
    var _k = useState(), rowData = _k[0], setRowData = _k[1];
    var _l = useState({ open: false, applicationId: null }), openDeleteConfirmation = _l[0], setOpenDeleteConfirmation = _l[1];
    var _m = useState({ ApplicationId: '' }), selectedApplicationForResubmit = _m[0], setSelectedApplicationForResubmit = _m[1];
    var _o = useState(false), isResubmitReqDocsStage = _o[0], setIsResubmitReqDocsStage = _o[1];
    var _p = useState({ json: {} }), applicationJsonPayload = _p[0], setApplicationJsonPayload = _p[1];
    var _q = useState(null), viewDetailsPayload = _q[0], setViewDetailsPayload = _q[1];
    var _r = useState(false), viewDetailsIsReqDocs = _r[0], setViewDetailsIsReqDocs = _r[1];
    var _s = useState(false), rowDetailsOpen = _s[0], setRowDetailsOpen = _s[1];
    var _t = useState(null), rowDetailsData = _t[0], setRowDetailsData = _t[1];
    var _u = useState(false), rowDetailsIsReqDocs = _u[0], setRowDetailsIsReqDocs = _u[1];
    var _v = useState({ right: null }), drawerState = _v[0], setDrawerState = _v[1];
    var _w = useState(false), openSuccessPopup = _w[0], setOpenSuccessPopup = _w[1];
    var _x = useState(false), openUnsavedChangesConfirmation = _x[0], setOpenUnsavedChangesConfirmation = _x[1];
    var _y = useState({ json: {} }), freezedApplicationJsonPayload = _y[0], setFreezedApplicationJsonPayload = _y[1];
    var _z = useState(0), activeTab = _z[0], setActiveTab = _z[1];
    var _0 = useState(1), currentPage = _0[0], setCurrentPage = _0[1];
    var _1 = useState(50), perPageCount = _1[0], setPerPageCount = _1[1];
    var _2 = useState([]), reqDocsList = _2[0], setReqDocsList = _2[1];
    var _3 = useState([]), freezedReqDocsList = _3[0], setFreezedReqDocsList = _3[1];
    var _4 = useState(false), isFetchingReqDocs = _4[0], setIsFetchingReqDocs = _4[1];
    var _5 = useState(null), reqDocsStatus = _5[0], setReqDocsStatus = _5[1];
    var _6 = useState(1), reqDocsCurrentPage = _6[0], setReqDocsCurrentPage = _6[1];
    var _7 = useState(50), reqDocsPerPageCount = _7[0], setReqDocsPerPageCount = _7[1];
    var _8 = useState({
        Failed: undefined, Processing: undefined, Completed: undefined, Deleted: undefined,
    }), reqDocsPillCounts = _8[0], setReqDocsPillCounts = _8[1];
    var reqDocsRequestIdRef = useRef(0);
    var _9 = useState([]), selectedSubmissionRows = _9[0], setSelectedSubmissionRows = _9[1];
    var _10 = useState([]), selectedReqDocsRows = _10[0], setSelectedReqDocsRows = _10[1];
    var _11 = useState(false), isExporting = _11[0], setIsExporting = _11[1];
    var selectedRowsForExport = activeTab === 1 ? selectedReqDocsRows : selectedSubmissionRows;
    var getFailedApplications = function () {
        setIsFetching(true);
        setAdminList([]);
        api_service.get({
            endPoint: api_urls.GET_FAILED_APPLICATIONS,
            payLoad: {
                VendorId: selectedPortal == 'all' ? null : selectedPortal
            }
        }).then(function (res) {
            setIsFetching(false);
            if ((res === null || res === void 0 ? void 0 : res.data) && res.data.statusCode === 200) {
                var __failedApplications = res.data.data;
                __failedApplications === null || __failedApplications === void 0 ? void 0 : __failedApplications.map(function (eachApplication, index) {
                    eachApplication.CreatedTime = moment(eachApplication.CreatedTime).tz('America/New_York');
                });
                setAdminList(__failedApplications);
                setFreezedList(__failedApplications);
            }
        }).catch(function (err) { setIsFetching(false); });
    };
    var getReqDocsApplications = function () {
        var requestId = ++reqDocsRequestIdRef.current;
        setIsFetchingReqDocs(true);
        setReqDocsList([]);
        var __reqDocsPayload = {
            VendorId: selectedPortal == 'all' ? null : selectedPortal,
            RequestType: 'REQ_DOCS',
        };
        if (reqDocsStatus) {
            __reqDocsPayload.Status = REQ_DOCS_STATUS_MAP[reqDocsStatus];
        }
        api_service.get({
            endPoint: api_urls.GET_FAILED_APPLICATIONS,
            payLoad: __reqDocsPayload,
        }).then(function (res) {
            if (requestId !== reqDocsRequestIdRef.current)
                return;
            setIsFetchingReqDocs(false);
            if ((res === null || res === void 0 ? void 0 : res.data) && res.data.statusCode === 200) {
                var __reqDocsApplications_1 = res.data.data;
                __reqDocsApplications_1 === null || __reqDocsApplications_1 === void 0 ? void 0 : __reqDocsApplications_1.map(function (eachApplication, index) {
                    eachApplication.CreatedTime = moment(eachApplication.CreatedTime).tz('America/New_York');
                });
                setReqDocsList(__reqDocsApplications_1);
                setFreezedReqDocsList(__reqDocsApplications_1);
                if (!reqDocsStatus) {
                    var __counts_1 = { Failed: 0, Processing: 0, Completed: 0, Deleted: 0 };
                    __reqDocsApplications_1 === null || __reqDocsApplications_1 === void 0 ? void 0 : __reqDocsApplications_1.forEach(function (item) {
                        var key = STATUS_VALUE_TO_KEY[item === null || item === void 0 ? void 0 : item.Status];
                        if (key)
                            __counts_1[key] += 1;
                    });
                    setReqDocsPillCounts(__counts_1);
                    setReqDocsStatus('Failed');
                }
                else {
                    setReqDocsPillCounts(function (prev) {
                        var _a;
                        var _b;
                        return (__assign(__assign({}, prev), (_a = {}, _a[reqDocsStatus] = (_b = __reqDocsApplications_1 === null || __reqDocsApplications_1 === void 0 ? void 0 : __reqDocsApplications_1.length) !== null && _b !== void 0 ? _b : 0, _a)));
                    });
                }
            }
        }).catch(function (err) {
            if (requestId !== reqDocsRequestIdRef.current)
                return;
            setIsFetchingReqDocs(false);
        });
    };
    var getFailedApplicationSyncData = function (applicationId) {
        setIsFetching(true);
        api_service.get({
            endPoint: "".concat(api_urls.GET_FAILED_APPLICATION_SYNC_DATA, "/").concat(applicationId),
        }).then(function (res) {
            var _a, _b, _c, _d;
            setIsFetching(false);
            if ((res === null || res === void 0 ? void 0 : res.data) && res.data.statusCode === 200) {
                var __syncPayload = safeJsonParse((_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.SyncPayload);
                setApplicationJsonPayload({ json: __syncPayload });
                setFreezedApplicationJsonPayload({ json: __syncPayload });
            }
            else {
                utility.alert((_d = (_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message);
            }
        }).catch(function (err) { setIsFetching(false); });
    };
    var tableActionHandler = function (rowData, actionType) {
        console.log('rowData:', rowData);
        console.log('actionType:', actionType);
        if (actionType === 'Resubmit') {
            setSelectedApplicationForResubmit(rowData);
            setIsResubmitReqDocsStage(false);
            getFailedApplicationSyncData(rowData.ApplicationId);
        }
        else if (actionType === 'Delete') {
            setOpenDeleteConfirmation({ open: true, applicationId: rowData === null || rowData === void 0 ? void 0 : rowData.ApplicationId, pricingResubmitId: rowData === null || rowData === void 0 ? void 0 : rowData.Id });
        }
        else if (actionType === 'AppDetails') {
            handleViewDetails(rowData);
        }
    };
    var reqDocsActionHandler = function (rowData, actionType) {
        if (actionType === 'Resubmit') {
            setSelectedApplicationForResubmit(rowData);
            setIsResubmitReqDocsStage(true);
            var __syncPayload = safeJsonParse(rowData === null || rowData === void 0 ? void 0 : rowData.Payload);
            setApplicationJsonPayload({ json: __syncPayload });
            setFreezedApplicationJsonPayload({ json: __syncPayload });
        }
        else if (actionType === 'Delete') {
            setOpenDeleteConfirmation({ open: true, applicationId: rowData === null || rowData === void 0 ? void 0 : rowData.ApplicationId, pricingResubmitId: rowData === null || rowData === void 0 ? void 0 : rowData.Id });
        }
        else if (actionType === 'AppDetails') {
            handleViewDetails(rowData);
        }
    };
    var handleRowClick = function (__rowData) {
        setRowDetailsData(__rowData);
        setRowDetailsIsReqDocs(activeTab === 1);
        setRowDetailsOpen(true);
    };
    var handleRowDetailsClose = function () {
        setRowDetailsData(null);
        setRowDetailsOpen(false);
    };
    var handleViewDetails = function (__rowData) {
        setRowData(__rowData);
        setUserAction('View');
        setViewDetailsPayload(null);
        setViewDetailsIsReqDocs(activeTab === 1);
        if (activeTab === 0) {
            api_service.get({
                endPoint: "".concat(api_urls.GET_FAILED_APPLICATION_SYNC_DATA, "/").concat(__rowData === null || __rowData === void 0 ? void 0 : __rowData.ApplicationId),
            }).then(function (res) {
                var _a, _b;
                if ((res === null || res === void 0 ? void 0 : res.data) && res.data.statusCode === 200) {
                    setViewDetailsPayload(safeJsonParse((_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.SyncPayload));
                }
            }).catch(function (err) { console.log('error fetching application sync data:', err); });
        }
        else {
            setViewDetailsPayload(safeJsonParse(__rowData === null || __rowData === void 0 ? void 0 : __rowData.Payload));
        }
        setOpen(true);
    };
    var handleClose = function () {
        setRowData(null);
        setViewDetailsPayload(null);
        setOpen(false);
    };
    var handleExport = function (format) { return __awaiter(void 0, void 0, void 0, function () {
        var rows, isReqDocsStage, items, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    rows = selectedRowsForExport;
                    if (!rows.length)
                        return [2];
                    isReqDocsStage = activeTab === 1;
                    setIsExporting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4, Promise.all(rows.map(function (row) { return __awaiter(void 0, void 0, void 0, function () {
                            var res, err_2;
                            var _a, _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        if (isReqDocsStage) {
                                            return [2, { gridRow: row, payload: safeJsonParse(row === null || row === void 0 ? void 0 : row.Payload) }];
                                        }
                                        _c.label = 1;
                                    case 1:
                                        _c.trys.push([1, 3, , 4]);
                                        return [4, api_service.get({
                                                endPoint: "".concat(api_urls.GET_FAILED_APPLICATION_SYNC_DATA, "/").concat(row === null || row === void 0 ? void 0 : row.ApplicationId),
                                                showLoader: false,
                                            })];
                                    case 2:
                                        res = _c.sent();
                                        return [2, { gridRow: row, payload: safeJsonParse((_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.SyncPayload) }];
                                    case 3:
                                        err_2 = _c.sent();
                                        return [2, { gridRow: row, payload: null }];
                                    case 4: return [2];
                                }
                            });
                        }); }))];
                case 2:
                    items = _a.sent();
                    return [4, exportApplications(items, format, isReqDocsStage, isReqDocsStage ? reqDocsStatus : null)];
                case 3:
                    _a.sent();
                    return [3, 6];
                case 4:
                    err_1 = _a.sent();
                    utility.alert('Failed to export application data.');
                    return [3, 6];
                case 5:
                    setIsExporting(false);
                    return [7];
                case 6: return [2];
            }
        });
    }); };
    var refreshReqDocsAfterAction = function () {
        if (reqDocsStatus === null) {
            getReqDocsApplications();
        }
        else {
            setReqDocsStatus(null);
        }
    };
    var handleDeleteFailedApplication = function (applicationId, pricingResubmitId) {
        var queryParams = new URLSearchParams();
        if (applicationId != null)
            queryParams.append('ApplicationId', String(applicationId));
        if (pricingResubmitId != null)
            queryParams.append('PricingResubmitId', String(pricingResubmitId));
        api_service.delete({
            endPoint: "".concat(api_urls.DELETE_FAILED_APPLICATION, "?").concat(queryParams.toString()),
        }).then(function (res) {
            var _a;
            if (res && res.data.statusCode === 200) {
                if (activeTab === 1) {
                    refreshReqDocsAfterAction();
                }
                else {
                    getFailedApplications();
                }
            }
            else {
                utility.alert((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.message);
            }
        }).catch(function (err) {
            console.log("error in delete failed application:", err);
        });
    };
    var handleResubmitApplication = function () {
        var __applicationJsonPayload = null;
        try {
            if (applicationJsonPayload === null || applicationJsonPayload === void 0 ? void 0 : applicationJsonPayload.text) {
                __applicationJsonPayload = JSON.parse(applicationJsonPayload === null || applicationJsonPayload === void 0 ? void 0 : applicationJsonPayload.text);
            }
            else if (applicationJsonPayload === null || applicationJsonPayload === void 0 ? void 0 : applicationJsonPayload.json) {
                __applicationJsonPayload = applicationJsonPayload === null || applicationJsonPayload === void 0 ? void 0 : applicationJsonPayload.json;
            }
        }
        catch (err) {
            utility.alert('The JSON payload is invalid. Please fix it before submitting.');
            return;
        }
        var __endpoint = isResubmitReqDocsStage ? api_urls.RESUBMIT_PRICING_APPLICATION : api_urls.RESUBMIT_FAILED_APPLICATION;
        var __payload = isResubmitReqDocsStage
            ? {
                PricingAppId: selectedApplicationForResubmit === null || selectedApplicationForResubmit === void 0 ? void 0 : selectedApplicationForResubmit.Id,
                Payload: __applicationJsonPayload,
            }
            : {
                ApplicationId: selectedApplicationForResubmit === null || selectedApplicationForResubmit === void 0 ? void 0 : selectedApplicationForResubmit.ApplicationId,
                Source: selectedApplicationForResubmit === null || selectedApplicationForResubmit === void 0 ? void 0 : selectedApplicationForResubmit.Source,
                Payload: __applicationJsonPayload
            };
        api_service.post({
            endPoint: __endpoint,
            payLoad: __payload,
            showLoader: true
        }).then(function (res) {
            var _a;
            if ((res === null || res === void 0 ? void 0 : res.data) && res.data.statusCode === 200) {
                setApplicationJsonPayload({ json: {} });
                toggleDrawer('right', false, "close")();
                setSelectedApplicationForResubmit({ ApplicationId: '' });
                setOpenSuccessPopup(true);
            }
            else {
                utility.alert((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.message);
            }
        }).catch(function (err) {
            console.log('handleSaveDealerConfiguration ~ err:', err);
        });
    };
    var toggleDrawer = function (anchor, open, appName) { return function () {
        var _a;
        setDrawerState(__assign(__assign({}, drawerState), (_a = {}, _a[anchor] = open ? appName : null, _a)));
    }; };
    var handleCancelChanges = function () {
        try {
            var currentPayload = (applicationJsonPayload === null || applicationJsonPayload === void 0 ? void 0 : applicationJsonPayload.text) ? JSON.parse(applicationJsonPayload.text) : applicationJsonPayload.json;
            if (deepEqual(currentPayload, freezedApplicationJsonPayload === null || freezedApplicationJsonPayload === void 0 ? void 0 : freezedApplicationJsonPayload.json)) {
                setDrawerState({ 'right': null });
            }
            else {
                setOpenUnsavedChangesConfirmation(true);
            }
        }
        catch (err) {
            setOpenUnsavedChangesConfirmation(true);
        }
    };
    var list = function (anchor, appName) { return (React.createElement(Box, { role: "presentation", className: "cstDrawer", p: 2.5 },
        React.createElement(Stack, { direction: 'row', alignItems: 'center', justifyContent: 'space-between', mb: 2 },
            React.createElement(Typography, { variant: 'h5', fontWeight: 700 }, appName),
            React.createElement(CloseIcon, { onClick: handleCancelChanges })),
        React.createElement(Stack, { alignItems: 'center', justifyContent: 'flex-start', sx: {
                height: 'calc(100dvh - 158px)',
                overflow: 'auto',
                borderTop: '1px solid #80808036',
                borderBottom: '1px solid #80808036',
                marginBottom: '16px',
                padding: '8px 0px',
            } },
            React.createElement(SvelteJSONEditor, { onChange: function (content) {
                    setApplicationJsonPayload(content);
                }, content: applicationJsonPayload })),
        React.createElement(Stack, { direction: 'row', alignItems: 'center', justifyContent: 'flex-end', spacing: 2 },
            React.createElement(Button, { onClick: handleCancelChanges, variant: "outlined", sx: function (theme) { return ({
                    color: theme.palette.primary.main,
                    borderRadius: '30px',
                    borderColor: theme.palette.primary.main,
                }); } }, "Cancel"),
            React.createElement(Box, { sx: function (theme) { return ({
                    '& .MuiButtonBase-root': {
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                        padding: '6px 8px',
                        borderRadius: '30px'
                    }
                }); } },
                React.createElement(Button, { type: "submit", variant: "contained", color: "primary", fullWidth: true, className: "commonBtn ", onClick: handleResubmitApplication, disabled: JSON.stringify(applicationJsonPayload) && Object.keys(applicationJsonPayload).length ? false : true }, "Submit Application"))))); };
    useEffect(function () {
        var _a;
        if ((applicationJsonPayload === null || applicationJsonPayload === void 0 ? void 0 : applicationJsonPayload.json) && ((_a = Object.keys(applicationJsonPayload === null || applicationJsonPayload === void 0 ? void 0 : applicationJsonPayload.json)) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            setDrawerState({ right: selectedApplicationForResubmit.ApplicationId });
        }
    }, [applicationJsonPayload === null || applicationJsonPayload === void 0 ? void 0 : applicationJsonPayload.json]);
    useEffect(function () {
        var searchTerm = searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase();
        if (searchTerm === '') {
            setAdminList(freezedList);
        }
        else {
            var filteredResults = freezedList.filter(function (item) { var _a; return (_a = item === null || item === void 0 ? void 0 : item.CustomerName) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchTerm); });
            setAdminList(filteredResults);
        }
        setCurrentPage(1);
    }, [searchText]);
    useEffect(function () {
        var searchTerm = searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase();
        if (searchTerm === '') {
            setReqDocsList(freezedReqDocsList);
        }
        else {
            var filteredResults = freezedReqDocsList.filter(function (item) { var _a; return (_a = item === null || item === void 0 ? void 0 : item.CustomerName) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchTerm); });
            setReqDocsList(filteredResults);
        }
        setReqDocsCurrentPage(1);
    }, [searchText]);
    useEffect(function () {
        if (selectedPortal) {
            getFailedApplications();
        }
    }, [selectedPortal]);
    useEffect(function () {
        api_service.get({
            endPoint: api_urls.VENDOR_LIST,
        }).then(function (res) {
            if ((res === null || res === void 0 ? void 0 : res.data) && res.data.statusCode === 200) {
                var vendorOptions = res.data.data;
                vendorOptions.unshift({ Id: 'all', Name: 'All' });
                setVendorList(vendorOptions);
            }
        }).catch(function (err) { console.log('error:', err); });
    }, []);
    useEffect(function () {
        setSearchText('');
    }, [freezedList === null || freezedList === void 0 ? void 0 : freezedList.length]);
    var handlePortalSelection = function (e) {
        var value = e.target.value;
        var vendor = vendorList === null || vendorList === void 0 ? void 0 : vendorList.find(function (item) { return item.Id === value; });
        setSelectedPortal(value);
        setSelectedVendor({ Id: value, Name: vendor === null || vendor === void 0 ? void 0 : vendor.Name });
    };
    useEffect(function () {
        getReqDocsApplications();
    }, [reqDocsStatus, selectedPortal]);
    useEffect(function () {
        if (activeTab === 1) {
            getReqDocsApplications();
        }
        else {
            getFailedApplications();
        }
    }, [activeTab]);
    useEffect(function () {
        setReqDocsCurrentPage(1);
    }, [reqDocsStatus]);
    var paginatedList = useMemo(function () {
        var start = (currentPage - 1) * perPageCount;
        return (adminList || []).slice(start, start + perPageCount);
    }, [adminList, currentPage, perPageCount]);
    var reqDocsPaginatedList = useMemo(function () {
        var start = (reqDocsCurrentPage - 1) * reqDocsPerPageCount;
        return (reqDocsList || []).slice(start, start + reqDocsPerPageCount);
    }, [reqDocsList, reqDocsCurrentPage, reqDocsPerPageCount]);
    var submissionStageContent = (React.createElement(Box, { key: "submission-stage-tab", sx: {
            border: "1px solid ".concat(baseColors.greyPreset[40]),
            borderRadius: 2,
            mx: 2,
            mt: 2,
            mb: 2,
            overflow: 'hidden',
        } },
        React.createElement(Box, null,
            React.createElement(ResubmitTableSection, { dataToDisplay: paginatedList, isFetching: isFetching, actionHandler: tableActionHandler, onRowClick: handleRowClick, canUpdate: canUpdate, hasDelete: canDelete, isActionColumn: canUpdate || canDelete, currentPage: currentPage, perPageCount: perPageCount, setCurrentPage: setCurrentPage, setPerPageCount: setPerPageCount, totalCount: (adminList || []).length, onSelectionChange: setSelectedSubmissionRows }))));
    var reqDocsStageContent = (React.createElement(Box, { key: "req-docs-stage-tab", sx: {
            border: "1px solid ".concat(baseColors.greyPreset[40]),
            borderRadius: 2,
            mx: 2,
            mt: 2,
            mb: 2,
            overflow: 'hidden',
        } },
        React.createElement(Box, { sx: { p: '10px 16px', backgroundColor: baseColors.fullWhite } },
            React.createElement(ResubmitStatusPills, { counts: reqDocsPillCounts, activeStatus: reqDocsStatus, onSelect: setReqDocsStatus })),
        React.createElement(Box, null,
            React.createElement(ResubmitTableSection, { key: reqDocsStatus !== null && reqDocsStatus !== void 0 ? reqDocsStatus : 'unfiltered', dataToDisplay: reqDocsPaginatedList, isFetching: isFetchingReqDocs, actionHandler: reqDocsActionHandler, onRowClick: handleRowClick, canUpdate: canUpdate && reqDocsStatus === 'Failed', hasDelete: canDelete && reqDocsStatus === 'Failed', isActionColumn: (canUpdate || canDelete) && (reqDocsStatus === 'Failed' || reqDocsStatus === 'Processing'), currentPage: reqDocsCurrentPage, perPageCount: reqDocsPerPageCount, setCurrentPage: setReqDocsCurrentPage, setPerPageCount: setReqDocsPerPageCount, totalCount: (reqDocsList || []).length, onSelectionChange: setSelectedReqDocsRows, isReqDocsStage: true, hideErrorMessageColumn: reqDocsStatus === 'Completed' }))));
    var tabs = [
        { label: React.createElement(TabLabelWithCount, { label: "Submission Stage", count: (adminList || []).length }), content: submissionStageContent },
        { label: React.createElement(TabLabelWithCount, { label: "Req Docs Stage", count: reqDocsPillCounts.Failed }), content: reqDocsStageContent },
    ];
    return (React.createElement(Box, null,
        React.createElement(Box, { sx: {
                '& .tabHeader': {
                    backgroundColor: '#F3F4F6',
                    px: 2,
                    py: 0.5,
                    pt: 2
                },
            } },
            React.createElement(CommonTab, { tabs: tabs, activeIndex: activeTab, onTabChange: setActiveTab, trailingContent: React.createElement(Stack, { direction: "row", spacing: 1.5, alignItems: "center", sx: { minWidth: 560 } },
                    selectedRowsForExport.length > 0 && (React.createElement(Button, { variant: "outlined", disabled: isExporting, onClick: function () { return handleExport('csv'); }, startIcon: React.createElement(IosShareOutlinedIcon, { sx: { fontSize: 18 } }), sx: {
                            height: TOOLBAR_CONTROL_HEIGHT,
                            borderRadius: '8px',
                            whiteSpace: 'nowrap',
                            textTransform: 'none',
                            fontWeight: 600,
                            color: EXPORT_COLOR,
                            borderColor: EXPORT_COLOR,
                            '&:hover': {
                                borderColor: EXPORT_COLOR,
                                backgroundColor: "".concat(EXPORT_COLOR, "14"),
                            },
                        } }, "Export(".concat(selectedRowsForExport.length, ")"))),
                    React.createElement(Box, { sx: { flex: 1, minWidth: 260 } },
                        React.createElement(SearchField, { value: searchText, onSearch: setSearchText, placeholder: "Search By Customer Name", debounceTimer: 500, showSearchIcon: true, sx: {
                                '& .MuiInputBase-colorPrimary': {
                                    borderRadius: '4px !important',
                                    border: "1px solid ".concat(baseColors.greyPreset[20], " !important"),
                                    height: "".concat(TOOLBAR_CONTROL_HEIGHT, "px !important"),
                                },
                            } })),
                    React.createElement(Box, { sx: {
                            minWidth: 220,
                            '& .MuiFormControl-root > span': { display: 'none' },
                            '& .MuiFormHelperText-root': { display: 'none' },
                            '& .MuiOutlinedInput-root': {
                                height: "".concat(TOOLBAR_CONTROL_HEIGHT, "px !important"),
                                minHeight: "".concat(TOOLBAR_CONTROL_HEIGHT, "px !important"),
                            },
                        } },
                        React.createElement(AutoCompleteDD, { options: vendorList !== null && vendorList !== void 0 ? vendorList : [], displayKey: 'Name', valueKey: 'Id', label: '', placeholder: 'All Dealers', handleChange: handlePortalSelection, selectedValue: selectedVendor, name: "PortalId", handleBlur: function () { } }))) })),
        React.createElement(Box, null,
            React.createElement(ViewApplicationDetailsDialog, { open: rowDetailsOpen, handleClose: handleRowDetailsClose, rowData: rowDetailsData, getAdminList: getFailedApplications, isReqDocsStage: rowDetailsIsReqDocs, activeStatus: rowDetailsIsReqDocs ? reqDocsStatus : null }),
            React.createElement(EditApplicationDrawer, { open: open, handleClose: handleClose, rowData: rowData, getAdminList: getFailedApplications, payloadData: viewDetailsPayload, isReqDocsStage: viewDetailsIsReqDocs })),
        React.createElement(SwipeableDrawer, { anchor: "right", open: drawerState['right'] === selectedApplicationForResubmit.ApplicationId, onClose: toggleDrawer('right', false, "close"), onOpen: toggleDrawer('right', true, "open"), sx: {
                '& .MuiPaper-root': {
                    background: '#fff',
                    minWidth: '600px',
                    maxWidth: '650px',
                }
            } }, list('right', selectedApplicationForResubmit.CustomerName)),
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.DELETE_CONFIRMATION_WARNING, titleText: 'Are you sure?', open: openDeleteConfirmation.open, key: "".concat(openDeleteConfirmation.open), message: 'Are you sure you want to Delete the Application?', acceptBtnText: 'Yes', denyBtnText: 'No', acceptCallBack: function () {
                handleDeleteFailedApplication(openDeleteConfirmation.applicationId, openDeleteConfirmation.pricingResubmitId);
                setOpenDeleteConfirmation({ open: false, applicationId: null });
            }, denyCallBack: function () {
                setOpenDeleteConfirmation({ open: false, applicationId: null });
            }, cancelCallBack: function () {
                setOpenDeleteConfirmation({ open: false, applicationId: null });
            } }),
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.UNSAVED_DATA_WARNING, titleText: 'Are you sure?', message: "Are you sure you want to Cancel the changes?", acceptBtnText: 'Yes', denyBtnText: 'No', acceptCallBack: useCallback(function () {
                setOpenUnsavedChangesConfirmation(false);
                setDrawerState({ right: null });
            }, [openUnsavedChangesConfirmation]), denyCallBack: useCallback(function () {
                setOpenUnsavedChangesConfirmation(false);
            }, []), open: openUnsavedChangesConfirmation, key: "".concat(openUnsavedChangesConfirmation), cancelCallBack: useCallback(function () {
                setOpenUnsavedChangesConfirmation(false);
            }, []) }),
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.SUCCESS_ALERT, titleText: 'Success!', message: "Application has been submitted successfully.", acceptBtnText: 'Ok', acceptCallBack: useCallback(function () {
                setOpenSuccessPopup(false);
                if (isResubmitReqDocsStage) {
                    refreshReqDocsAfterAction();
                }
                else {
                    getFailedApplications();
                }
            }, [openSuccessPopup, isResubmitReqDocsStage, reqDocsStatus]), open: openSuccessPopup, key: "".concat(openSuccessPopup) })));
};
export default ResubmitApplication;
